<template>
  <div v-if="contactModal==true" class="home-email-modal" @click.self="$emit('closeContact')">
    <div class="home-email-container">
      <p class="home-email-title">이메일 문의</p>
      <p class="home-email-address">{{ email }}</p>
      <p class="home-email-desc">문의 주시면 영업일 기준 1일 이내에 답변드려요.</p>

      <div class="home-email-button-container">
        <button class="home-email-button" id="copy" @click="copyEmail()">{{ copied ? '복사되었습니다' : '복사' }}</button>
        <button class="home-email-button" id="close" @click="$emit('closeContact')">닫기</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeContactModal',
  props: {
    contactModal: {
      typeof: Boolean,
      require: true,
      default: false
    },
  },
  data() {
    return {
      email: 'official@gosurveasy.com',
      copied: false
    }
  },
  watch: {
    contactModal(open) {
      this.copied = false
      document.documentElement.style.overflow = open ? 'hidden' : ''
      document.body.style.overflow = open ? 'hidden' : ''
    }
  },
  beforeUnmount() {
    document.documentElement.style.overflow = ''
    document.body.style.overflow = ''
  },
  methods: {
    copyEmail() {
      if(navigator.clipboard && window.isSecureContext){
        navigator.clipboard.writeText(this.email).then(() => {
          this.copied = true
        }).catch(() => {
          this.fallbackCopy()
        })
      }else{
        this.fallbackCopy()
      }
    },
    fallbackCopy() {
      const area = document.createElement('textarea')
      area.value = this.email
      area.style.position = 'fixed'
      area.style.opacity = '0'
      document.body.appendChild(area)
      area.select()
      try {
        document.execCommand('copy')
        this.copied = true
      } catch (e) {
        this.copied = false
      }
      document.body.removeChild(area)
    }
  }
}
</script>

<style>
.home-email-modal {
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.35);
  transition: opacity .3s ease;
  display: flex;
  justify-content: center;
  align-items: center;
}
.home-email-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-family: 'Noto Sans KR', sans-serif;
  width: 90%;
  max-width: 420px;
  padding: 30px 20px;
  margin: auto;
  background-color: rgb(255, 255, 255);
  border: 1.5px solid #ededed;
  border-radius: 20px;
  box-shadow: 1px 2px 3px rgba(56, 56, 56, 0.43);
  transition: all .3s ease;
  z-index: 999;
}
.home-email-title {
  text-align: center;
  font-size: 20px;
  font-weight: 700;
  color: #3d3d3d;
  margin-bottom: 18px;
}
.home-email-address {
  text-align: center;
  font-size: 18px;
  font-weight: 500;
  color: #0AAB00;
  word-break: break-all;
  margin-bottom: 10px;
}
.home-email-desc {
  text-align: center;
  font-size: 12px;
  color: #8d8d8d;
  margin-bottom: 0;
}
.home-email-button-container {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  margin-top: 25px;
}
.home-email-button {
  width: 130px;
  height: 32px;
  border-radius: 10px;
  font-size: 0.9rem;
  cursor: pointer;
  font-family: 'Noto Sans KR', sans-serif;
  background-color: #FFFFFF;
}
#copy {
  color: #0AAB00;
  border: 1.5px solid #0AAB00;
}
#close {
  color: #b0b0b0;
  border: 1.5px solid #b0b0b0;
}
</style>
